function createError(code, message, opts) {
  const error = new Error(message || code);
  error.code = code;
  error.isRetryable = opts == null ? void 0 : opts.isRetryable;
  return error;
}
function hasNestedError(error) {
  return error && typeof error === "object" && "error" in error;
}
function unwrapNestedError(error) {
  return hasNestedError(error) ? error.error : error;
}
export {
  createError,
  hasNestedError,
  unwrapNestedError
};
